import { render, staticRenderFns } from "./CompanySegment.vue?vue&type=template&id=0c360a1e&scoped=true"
import script from "./CompanySegment.vue?vue&type=script&lang=js"
export * from "./CompanySegment.vue?vue&type=script&lang=js"
import style0 from "./CompanySegment.vue?vue&type=style&index=0&id=0c360a1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c360a1e",
  null
  
)

export default component.exports